<div class="row">
  <div class="col-md-12">

    <div class="card shadow-lg border-0">

      <!-- Header -->
      <div class="card-header bg-primary text-white">
        <h3 class="mb-0">📊 Stock Report</h3>
      </div>

      <!-- Filters -->
      <div class="card-body">

        <div class="row mb-3">

          <div class="col-md-3">
            <label>From Date</label>
            <input type="date"
                   class="form-control"
                   [(ngModel)]="fromDate">
          </div>

          <div class="col-md-3">
            <label>To Date</label>
            <input type="date"
                   class="form-control"
                   [(ngModel)]="toDate">
          </div>

          <div class="col-md-2 d-flex align-items-end">
            <button class="btn btn-success w-100"
                    (click)="display()">
              Show
            </button>
          </div>

          <div class="col-md-2 d-flex align-items-end">
            <button class="btn btn-info w-100"
                    (click)="export_excel()"
                    [disabled]="!StockReport_Row?.length">
              Excel
            </button>
          </div>
          <div class="col-sm-6 col-md-2 d-flex align-items-end align-items-center">
  <div class="fw-bold ms-2" style="color: rgb(219, 45, 74);">
    Total Amount: {{ totalAmount | number:'1.2-2' }}
  </div>

        </div>

        <!-- Table -->
        <div class="table-responsive" *ngIf="StockReport_Row?.length; else noData">

          <table class="table table-bordered table-striped">

            <thead class="table-primary">
              <tr>
                <th>#</th>
                <th>Product Name</th>
                <th>Opening</th>
                <th>Purchase</th>
                <th>Split</th>
                <th>Sales</th>
                <th>Closing</th>
                <th>Stock Value</th>
              </tr>
            </thead>

            <tbody>

              <tr *ngFor="let row of StockReport_Row; let i=index">

                <td>{{i+1}}</td>

                <td>{{row['Product Name']}}</td>

                <td>{{row.Opening}}</td>

                <td>{{row.Purchase}}</td>

                <td>{{row.Split}}</td>

                <td>{{row.Sales}}</td>

                <td>{{row.Closing}}</td>

                <td>{{row['Stock Value']}}</td>

              </tr>

            </tbody>

          </table>

        </div>

        <ng-template #noData>
          <div class="text-center text-muted mt-4">
            No Data Found
          </div>
        </ng-template>

      </div>

    </div>

  </div>
</div>